<template>
  <div class="container">
    <h2 class="mb-4">Reporte de Observaciones</h2>

    <div v-if="loading">Cargando...</div>
    <div v-else-if="error" class="alert alert-danger">{{ error }}</div>
    <div v-else>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>ID</th>
            <th>Descripción</th>
            <th>Observación</th>
            <th>Detalle Planilla</th>
            <th>Estado</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in observaciones" :key="item.idPlaDetObs">
            <td>{{ item.idPlaDetObs }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.observacionDescripcion }}</td>
            <td>{{ item.planillaDetDescripcion }}</td>
            <td>{{ item.estado === "1" ? "Activo" : "Inactivo" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import api from "@/services/api";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";

export default {
  setup() {
    const route = useRoute();
    const p_idTramite = route.params.p_idtramite;
    alert(p_idTramite);
    const observaciones = ref([]);
    const loading = ref(true);
    const error = ref(null);

    const fetchObservaciones = async () => {
      try {
        const response = await api.delete(`/vwpladetobss/idtramite/${p_idTramite}`
        );
        observaciones.value = response.data.item || [];
      } catch (err) {
        error.value = "Error al obtener los datos";
      } finally {
        loading.value = false;
      }
    };

    onMounted(fetchObservaciones);

    return { observaciones, loading, error };
  },
};
</script>

<style scoped>
.container {
  max-width: 800px;
  margin: auto;
  padding: 20px;
}
</style>
